import headers from "app/requests/headers";

export const create = (params) => (
  fetch("/api/admin/validation_reports", {
    body: JSON.stringify({validation_report: params}),
    headers: headers(),
    method: "POST"
  }).then((response) => response.json())
);

export const destroy = (id) => (
  fetch(`/api/admin/validation_reports/${id}`, {
    headers: headers(),
    method: "DELETE"
  }).then((response) => response.json())
);

export const list = () => (
  fetch("/api/admin/validation_reports", {
    headers: headers(),
    method: "GET"
  }).then((response) => response.json())
);
